<div class="product-card" [ngClass]="{
    'product-card--layout--grid product-card--size--sm': layout === 'grid-sm',
    'product-card--layout--grid product-card--size--nl': layout === 'grid-nl',
    'product-card--layout--grid product-card--size--lg': layout === 'grid-lg',
    'product-card--layout--list':                        layout === 'list',
    'product-card--layout--horizontal':                  layout === 'horizontal'
}">
    <button class="product-card__quickview" type="button" appClick (click)="showQuickview()" [ngClass]="{'product-card__quickview--preload': showingQuickview}">
        <app-icon name="quickview-16" size="16"></app-icon>
        <span class="fake-svg-icon"></span>
    </button>

    <div *ngIf="product.badge" class="product-card__badges-list">
        <div *ngIf="product.badge=='New'" class="product-card__badge product-card__badge--new">New</div>
        <div *ngIf="product.badge=='Original'" class="product-card__badge product-card__badge--original">Original</div>
        <div *ngIf="product.badge=='Refurbished'" class="product-card__badge product-card__badge--refurbished">Refurbished</div>
        <div *ngIf="product.badge=='Used'" class="product-card__badge product-card__badge--used">Used</div>
        <div *ngIf="product.badge=='New Open Box'" class="product-card__badge product-card__badge--boxopened">New Open Box</div>
        <div *ngIf="product.badge=='New Factory Sealed'" class="product-card__badge ">New Factory Sealed</div>
    </div>

    <div class="product-card__image product-image">
        <a appClick [routerLink]="root.product(product)" *ngIf="product.thumbnail" class="product-image__body">
            <img class="product-image__img" [src]="product.thumbnail" alt="{{product.name}}">
        </a>
    </div>
    <div class="product-card__info">
        <div class="product-card__name">
            <a appClick [routerLink]="root.product(product)">{{ product.name }}</a>
        </div>
        <div style="margin-top: 5px;">
            <a style="color: black; text-align: center;" [routerLink]="root.product(product)">
                {{ product.descriptionshort }}
            </a>
        </div>
    </div>
    <div class="product-card__actions">
        <div class="product-card__availability">
            Status:
            <span *ngIf="product.availability === 'in-stock'" class="text-success">In Stock</span>
        </div>
        <div class="product-card__prices" *ngIf="!isuk">
            <ng-container *ngIf="product.priceoriginal && product.pricesale">
                <span class="product-card__new-price">{{ product.pricesale|currencyFormat : '$' }}&nbsp;&nbsp; </span>{{ ' ' }}
                <span class="product-card__old-price">  {{ product.priceoriginal|currencyFormat : '$'}}</span>
            </ng-container>
            <ng-container *ngIf="!product.priceoriginal">
                <span class="product-card__new-price">{{ product.pricesale|currencyFormat : '$' }}</span>{{ ' ' }}
                <!-- {{ product.pricesale|currencyFormat : '$'}} -->
            </ng-container>
            <ng-container *ngIf="!product.pricesale">
                <span class="product-card__old-price">{{ product.priceoriginal|currencyFormat : '$'}}</span>
                <!-- {{ product.priceoriginal|currencyFormat : '$'}} -->
            </ng-container>
        </div>
        <div class="product-card__prices" *ngIf="isuk">
            <ng-container *ngIf="product.priceoriginaluk && product.pricesaleuk">
                <span class="product-card__new-price">{{ product.pricesaleuk|currencyFormat : 'GBP' }}</span>{{ ' ' }}
                <span class="product-card__old-price">{{ product.priceoriginaluk|currencyFormat: 'GBP' }}</span>
            </ng-container>
            <ng-container *ngIf="!product.priceoriginaluk">
                <!-- {{ product.pricesale|currencyFormat : '$' }} -->
                <span class="product-card__new-price">{{ product.pricesaleuk|currencyFormat : 'GBP' }}</span>{{ ' ' }}
            </ng-container>
            <ng-container *ngIf="!product.pricesaleuk">
                <span class="product-card__old-price">{{ product.priceoriginaluk|currencyFormat: 'GBP' }}</span>
                <!-- {{ product.priceoriginal|currencyFormat : '$'}} -->

            </ng-container>
        </div>
        <div class="product-card__buttons">
            <button  class="btn btn-info product-card__addtocart p-1" type="button" appClick (click)="getquote(product.name)" [ngClass]="{'btn-loading': buyingNow}" >Get Quote</button>
            <button  class="btn btn-secondary product-card__addtocart product-card__addtocart--list" type="button" appClick (click)="getquote(product.name)" [ngClass]="{'btn-loading': buyingNow}">Get Quote</button> 
            <button *ngIf="product.pricesale" class="btn btn-primary product-card__addtocart p-1" type="button" appClick (click)="addToCart()" [ngClass]="{'btn-loading': addingToCart}"><i title="Add to Cart" class="fa fa-cart-plus" aria-hidden="true"></i></button>
            <button  *ngIf="product.pricesale" class="btn btn-secondary product-card__addtocart product-card__addtocart--list" type="button" appClick (click)="addToCart()" [ngClass]="{'btn-loading': addingToCart}"><i title="Add to Cart" class="fa fa-cart-plus" aria-hidden="true"></i></button>
            <button class="btn btn-light btn-svg-icon btn-svg-icon--fake-svg product-card__wishlist" type="button" appClick (click)="addToWishlist()" [ngClass]="{'btn-loading': addingToWishlist}">
                <app-icon title="Add to Wishlist" name="wishlist-16" size="16"></app-icon>
                <span class="fake-svg-icon fake-svg-icon--wishlist-16"></span>
            </button>


            <!-- <button class="btn btn-light btn-svg-icon btn-svg-icon--fake-svg product-card__compare" type="button" appClick (click)="addToCompare()" [ngClass]="{'btn-loading': addingToCompare}">
                <app-icon name="compare-16" size="16"></app-icon>
                <span class="fake-svg-icon fake-svg-icon--compare-16"></span>
            </button> -->
        </div>
    </div>
</div>
